import * as ActionTypes from './actionTypes.js';

const initialState = {
  commissionsWidgetState: {
    commissionsMonth: '',
  },
  campaignAdminPopup: false,
  fetchSignFormsDataForCampaignAdmin: {},
};

const dashboardReducers = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_CAMPAIGN_ADMIN_POPUP: {
      return { ...state, ...{ campaignAdminPopup: action.data } };
    }
    case ActionTypes.FETCH_CAMPAIGNADMIN_SIGNFORMS_DATA: {
      return { ...state, ...{ fetchCampaignAdminSignFormsData: action.payload } };
    }
    case ActionTypes.FETCH_CAMPAIGNADMIN_POPUPMESSAGE_DATA: {
      return { ...state, ...{ fetchCampaignAdminPopupMessageData: action.payload } };
    }
    case ActionTypes.FETCH_CAMPAIGN_AUTOPUSH_POPUP:
      return { ...state, campaignAutoPushData: action.payload };
    case ActionTypes.UPDATE_CAMPAIGN_AUTOPUSH_POPUP:
      return { ...state, data: action.data };
    default:
      return state;
  }
};

export default dashboardReducers;
